const formatPhoneNumber = (phone) => {
  if (!phone) return ""

  // Check if the number starts with a plus
  const hasPlus = phone.toString().startsWith("+")

  // Remove all non-digit characters
  const cleaned = ("" + phone).replace(/\D/g, "")

  let formatted

  // Handle different phone number lengths
  if (cleaned.length === 10) {
    // Format as (XXX) XXX-XXXX
    formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
  } else if (cleaned.length === 11) {
    // Handle 11-digit numbers (country code + number)
    formatted = cleaned.replace(/(\d)(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4")
  } else if (cleaned.length > 10) {
    // For numbers longer than 10 digits, just format the last 10 digits
    const lastTen = cleaned.slice(-10)
    formatted = lastTen.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
  } else if (cleaned.length === 7) {
    // Format as XXX-XXXX
    formatted = cleaned.replace(/(\d{3})(\d{4})/, "$1-$2")
  } else {
    return phone // Return as is if it doesn't match expected patterns
  }

  // Add back the plus sign if the original number had it
  return hasPlus ? `+${formatted}` : formatted
}

const formatCurrency = (amount, locale = "en-US", currency = "USD") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0)
}

export { formatPhoneNumber, formatCurrency }
